export function fiscalDocumentsEnabledFromOrg(
  org:
    | {
        fiscalDocumentsEnabled?: boolean;
        countryKey?: "BR" | "US" | null;
      }
    | null
    | undefined,
): boolean {
  if (org?.countryKey === "US") return false;
  return org?.fiscalDocumentsEnabled === true;
}
